
import { Goal } from "@/types/todo";
import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { CertificateData } from "./CertificateDialog";
import { styleClasses } from "./template/CertificateStyles";
import { CertificateHeader } from "./template/CertificateHeader";
import { CertificateContent } from "./template/CertificateContent";
import { CertificateFooter } from "./template/CertificateFooter";
import { CertificateCorners } from "./template/CertificateCorners";
import { CertificateBackground } from "./template/CertificateBackground";

interface CertificateTemplateProps {
  goal: Goal;
  userName: string;
  customData?: CertificateData;
}

export function CertificateTemplate({ goal, userName, customData }: CertificateTemplateProps) {
  const data = customData || {
    userName,
    goalTitle: goal.title,
    progress: goal.progress,
    dueDate: goal.dueDate,
    tagline: "Set your goals and achieve greatness!",
    style: "formal" as const,
  };

  const style = styleClasses[data.style || "formal"];
  const [userImageUrl, setUserImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (data.userImage) {
      setUserImageUrl(URL.createObjectURL(data.userImage));
      return () => {
        if (userImageUrl) URL.revokeObjectURL(userImageUrl);
      };
    } else {
      setUserImageUrl(null);
    }
  }, [data.userImage]);

  const shareUrl = `${window.location.origin}/certificate/${goal.id}`;

  return (
    <div className="w-full print-content">
      <div className="w-full aspect-[210/297] relative bg-white">
        <Card className={cn(
          "h-full border-4 relative overflow-hidden shadow-lg",
          "p-2 sm:p-4 md:p-8",
          style.border
        )}>
          <CertificateBackground style={style} />
          
          <div className={cn(
            "relative z-10 flex flex-col items-center justify-between h-full",
            "p-1 sm:p-2 md:p-4",
            style.layout
          )}>
            <CertificateHeader style={style} />
            <CertificateContent data={data} style={style} userImageUrl={userImageUrl} />
            <CertificateFooter style={style} userName={data.userName} shareUrl={shareUrl} />
          </div>

          <CertificateCorners style={style} />
        </Card>
      </div>
    </div>
  );
}
